import { connectRouter, routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { init, RematchRootState } from '@rematch/core';
import createLoadingPlugin from '@rematch/loading';
import auth from '../models/auth';
import exam from '../models/exam';
// import createHistory from 'history/createBrowserHistory';
import errors from '../models/errors';
import experts from '../models/experts';
import applicants from '../models/applicants';
import examApplications from '../models/examApplications';
import notifications from '../models/notifications';
import eventsState from '../models/events';
import qualifications from '../models/qualifications';
import accreditationCenters from '../models/accreditationCenters';
import exams from '../models/exams';
import general from '../models/general';
import users from '../models/users';

const createHistory = require('history').createBrowserHistory;

const models = {
    auth,
    users,
    errors,
    exam,
    exams,
    experts,
    applicants,
    examApplications,
    notifications,
    eventsState,
    qualifications,
    accreditationCenters,
    general,
};

export const browserHistory: History = createHistory();

export const store = init({
    models,
    plugins: [createLoadingPlugin({})],
    redux: {
        initialState: {},
        reducers: {
            router: connectRouter(browserHistory),
        },
        middlewares: [
            routerMiddleware(browserHistory),
        ],
    },
});


export type Store = typeof store
export type Dispatch = typeof store.dispatch
export type IRootState = RematchRootState<typeof models> & LoadingPlugin;

interface LoadingPlugin {
    loading: {
        models: RematchRootState<typeof models>;
        effects: Dispatch;
    };
}
